import {
  menu,
  type MenuConfig,
} from '@blocksuite/affine-components/context-menu';

import type { PropertyConfigMenuContext } from '../../core/property/renderer.js';

export interface CheckboxPropertyData {
  strikeTitle?: boolean;
  completedAtPropertyId?: string;
}

export const buildCheckboxConfigMenu = (
  ctx: PropertyConfigMenuContext<CheckboxPropertyData>
): MenuConfig[] => {
  const { property } = ctx;
  const data = property.data$.value;

  const dateColumns = property.view.propertiesRaw$.value.filter(
    p => p.type$.value === 'date'
  );
  const currentTarget = dateColumns.find(
    c => c.id === data.completedAtPropertyId
  );

  const strikeTitleItem = menu.action({
    name: 'Strike through title',
    isSelected: data.strikeTitle === true,
    select: () =>
      property.dataUpdate(d => ({ ...d, strikeTitle: !d.strikeTitle })),
  });

  const createNewColumnItem = menu.action({
    name: 'Create new column…',
    hide: () => property.readonly$.value,
    select: () => {
      const id = property.view.propertyAdd(
        { id: property.id, before: false },
        { type: 'date', name: 'Completed at' }
      );
      if (id) {
        property.dataUpdate(d => ({ ...d, completedAtPropertyId: id }));
      }
    },
  });

  const completedAtSubMenu = menu.subMenu({
    name: `Record completion date to: ${
      currentTarget ? currentTarget.name$.value || 'Untitled' : 'Off'
    }`,
    options: {
      items: [
        menu.action({
          name: 'Off',
          isSelected: !data.completedAtPropertyId,
          select: () =>
            property.dataUpdate(d => ({
              ...d,
              completedAtPropertyId: undefined,
            })),
        }),
        ...dateColumns.map(c =>
          menu.action({
            name: c.name$.value || 'Untitled',
            isSelected: data.completedAtPropertyId === c.id,
            select: () =>
              property.dataUpdate(d => ({ ...d, completedAtPropertyId: c.id })),
          })
        ),
        createNewColumnItem,
      ],
    },
  });

  return [menu.group({ items: [strikeTitleItem, completedAtSubMenu] })];
};
